/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Modification de l'identité d'un indice. Les branches ne se modifient pas ici mais par `PUT /indices/{indiceId}/branches`.
 * @export
 * @interface UpdateIndiceCommand
 */
export interface UpdateIndiceCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateIndiceCommand
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIndiceCommand
     */
    label: string;
}

/**
 * Check if a given object implements the UpdateIndiceCommand interface.
 */
export function instanceOfUpdateIndiceCommand(value: object): value is UpdateIndiceCommand {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function UpdateIndiceCommandFromJSON(json: any): UpdateIndiceCommand {
    return UpdateIndiceCommandFromJSONTyped(json, false);
}

export function UpdateIndiceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIndiceCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'label': json['label'],
    };
}

export function UpdateIndiceCommandToJSON(json: any): UpdateIndiceCommand {
    return UpdateIndiceCommandToJSONTyped(json, false);
}

export function UpdateIndiceCommandToJSONTyped(value?: UpdateIndiceCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'label': value['label'],
    };
}

